(function ($) {
    $(function () {
        const addAltToImg = () => {
            if ($('img').length > 0) {
                $('img').each(function () {
                    const currentImg = $(this);
                    if (!currentImg.attr('alt')) {
                        const imgSrc = currentImg.attr('src');
                        const altText = imgSrc.split('/').pop().split('.')[0];
                        currentImg.attr('alt', altText);
                    }
                });
            }
        }

        function init() {
            console.log("img-alt-------------------js");
            addAltToImg()
            window.addAltToImg = addAltToImg;

        }
        init();
    });
})(jQuery, window, document);



